import { FC, useState } from 'react';
import { createInsightsApolloClient } from 'app/modules/insights/utils/createAuthorizedInsightsApolloClient';
import { ApolloProvider } from '@apollo/client';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import ReportFailedToBuildMessage from 'app/modules/public/modules/pdfReports/components/ReportFailedToBuildMessage';
import ReportApi from 'api/report';
import { queryKey } from 'constants/queryKey';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import Skeleton from 'react-loading-skeleton';
import CustomReportPDFExport from 'app/modules/public/modules/pdfReports/modules/customReport/components/CustomReportPDFExport';
import UserApi from 'api/user';
import clsx from 'clsx';
import RequestHeaders from 'app/constants/requestHeaders';

type Props = {};

const CustomReportRoute: FC<Props> = (props) => {
  const { id } = useParams();
  const [params] = useQueryParams({
    token: StringParam,
    accountId: NumberParam,
    mode: StringParam,
  });
  const token = params.token;
  const accountId = params.accountId ?? undefined;
  const mode = params.mode;
  const userUseMeridianTime = useQuery(
    queryKey.reportsUserUseMeridianTime(token || undefined),
    async () => {
      if (!token) return true;

      const rest = await UserApi.getData({
        headers: {
          [RequestHeaders.HttpJwtToken]: token ?? '',
          ...(accountId !== undefined && {
            [RequestHeaders.AccountId]: String(accountId),
          }),
        },
      });

      return rest.useMeridianTime;
    },
  );

  const [client] = useState(() =>
    createInsightsApolloClient(token ?? '', accountId),
  );

  const { isLoading, data } = useQuery(
    queryKey.reportDetail(Number(id)),
    () => {
      return ReportApi.detail(Number(id), token ?? undefined, accountId);
    },
    {
      enabled: !!token,
    },
  );

  if (!token || !id) {
    return <ReportFailedToBuildMessage />;
  }

  if (isLoading) {
    return <Skeleton width="100%" height={'200px'} />;
  }

  if (!data) {
    return <ReportFailedToBuildMessage />;
  }

  return (
    <ApolloProvider client={client}>
      <div
        className={clsx(
          'tw-h-full tw-w-full',
          mode === 'preview' && 'tw-bg-gradient-to-b tw-px-16 tw-py-8',
        )}
      >
        <CustomReportPDFExport
          report={data}
          is12hDateFormat={!userUseMeridianTime.data}
          minimal={mode === 'minimal'}
        />
      </div>
    </ApolloProvider>
  );
};
export default CustomReportRoute;
